// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    background-color: #f8f9fa;
    color: #333;
}

.container {
    padding: 20px;
    max-width: 1800px;
    margin: 0 auto;
}

h1, h2, h3, h4, h5, h6 {
    font-family: 'Poppins', sans-serif;
    color: #2c3e50;
}

.page-title {
    font-size: 1.75rem;
    font-weight: 700;
    margin-bottom: 1rem;
}

.form-control, select, textarea {
    width: 100%;
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus, select:focus, textarea:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Buttons */
.btn {
    display: inline-block;
    font-weight: 400;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
            user-select: none;
    background-color: #007bff;
    border: 1px solid #007bff;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn:hover {
    color: #fff;
    background-color: #0056b3;
    border-color: #004085;
}

.btn-danger {
    background-color: #dc3545;
    border-color: #dc3545;
}

.btn-danger:hover {
    background-color: #c82333;
    border-color: #bd2130;
}

/* Tables */
.table {
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
    border-collapse: collapse;
}

.table th,
.table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}

.table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    background-color: #f8f9fa;
    font-weight: 600;
}

.table tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
    transform: translateY(-2px);
}

/* Cards */
.card {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem;
}

.card-title {
    margin-bottom: 0.75rem;
    font-size: 1.25rem;
    font-weight: 500;
}

/* Utilities */
.mt-4 {
    margin-top: 1.5rem;
}

.mb-4 {
    margin-bottom: 1.5rem;
}

.text-center {
    text-align: center;
}

/* Responsive */
@media (max-width: 768px) {
    .container {
        padding: 10px;
    }

    .table-responsive {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
}


/* global-styles.css */

.categories-container {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    max-width: 280px;
}

.category-section,
.price-section {
    margin-bottom: 32px;
}

.categories-container h2 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eee;
}

.radio-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.radio-label {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.radio-label input[type="radio"] {
    display: none;
}

.radio-custom {
    width: 18px;
    height: 18px;
    border: 2px solid #ddd;
    border-radius: 50%;
    margin-right: 8px;
    position: relative;
}

.radio-custom::before {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    background: #0056b3;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.2s ease;
}

.radio-label input[type="radio"]:checked + .radio-custom {
    border-color: #0056b3;
}

.radio-label input[type="radio"]:checked + .radio-custom::before {
    transform: translate(-50%, -50%) scale(1);
}

.label-text {
    font-size: 14px;
    color: #4a4a4a;
}

.radio-label input[type="radio"]:checked ~ .label-text {
    color: #0056b3;
    font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/global-styles.css"],"names":[],"mappings":"AAAA;IACI,uKAAuK;IACvK,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,wEAAwE;AAC5E;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,gDAAgD;AACpD;;AAEA,YAAY;AACZ;IACI,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,yBAAiB;YAAjB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,qIAAqI;AACzI;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,WAAW;AACX;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA,UAAU;AACV;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,sCAAsC;IACtC,sBAAsB;IACtB,mDAAmD;AACvD;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,iCAAiC;IACrC;AACJ;;;AAGA,sBAAsB;;AAEtB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB","sourcesContent":["body {\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n    background-color: #f8f9fa;\n    color: #333;\n}\n\n.container {\n    padding: 20px;\n    max-width: 1800px;\n    margin: 0 auto;\n}\n\nh1, h2, h3, h4, h5, h6 {\n    font-family: 'Poppins', sans-serif;\n    color: #2c3e50;\n}\n\n.page-title {\n    font-size: 1.75rem;\n    font-weight: 700;\n    margin-bottom: 1rem;\n}\n\n.form-control, select, textarea {\n    width: 100%;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.875rem;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.form-control:focus, select:focus, textarea:focus {\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n/* Buttons */\n.btn {\n    display: inline-block;\n    font-weight: 400;\n    color: #fff;\n    text-align: center;\n    vertical-align: middle;\n    user-select: none;\n    background-color: #007bff;\n    border: 1px solid #007bff;\n    padding: 0.375rem 0.75rem;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    border-radius: 0.25rem;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.btn:hover {\n    color: #fff;\n    background-color: #0056b3;\n    border-color: #004085;\n}\n\n.btn-danger {\n    background-color: #dc3545;\n    border-color: #dc3545;\n}\n\n.btn-danger:hover {\n    background-color: #c82333;\n    border-color: #bd2130;\n}\n\n/* Tables */\n.table {\n    width: 100%;\n    margin-bottom: 1rem;\n    color: #212529;\n    border-collapse: collapse;\n}\n\n.table th,\n.table td {\n    padding: 0.75rem;\n    vertical-align: top;\n    border-top: 1px solid #dee2e6;\n}\n\n.table thead th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #dee2e6;\n    background-color: #f8f9fa;\n    font-weight: 600;\n}\n\n.table tbody tr:nth-of-type(odd) {\n    background-color: rgba(0, 0, 0, 0.05);\n    transform: translateY(-2px);\n}\n\n/* Cards */\n.card {\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: border-box;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    border-radius: 0.25rem;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n.card-body {\n    flex: 1 1 auto;\n    min-height: 1px;\n    padding: 1.25rem;\n}\n\n.card-title {\n    margin-bottom: 0.75rem;\n    font-size: 1.25rem;\n    font-weight: 500;\n}\n\n/* Utilities */\n.mt-4 {\n    margin-top: 1.5rem;\n}\n\n.mb-4 {\n    margin-bottom: 1.5rem;\n}\n\n.text-center {\n    text-align: center;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .container {\n        padding: 10px;\n    }\n\n    .table-responsive {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n}\n\n\n/* global-styles.css */\n\n.categories-container {\n    background: #fff;\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n    max-width: 280px;\n}\n\n.category-section,\n.price-section {\n    margin-bottom: 32px;\n}\n\n.categories-container h2 {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #eee;\n}\n\n.radio-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.radio-label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.radio-label input[type=\"radio\"] {\n    display: none;\n}\n\n.radio-custom {\n    width: 18px;\n    height: 18px;\n    border: 2px solid #ddd;\n    border-radius: 50%;\n    margin-right: 8px;\n    position: relative;\n}\n\n.radio-custom::before {\n    content: \"\";\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    background: #0056b3;\n    border-radius: 50%;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) scale(0);\n    transition: transform 0.2s ease;\n}\n\n.radio-label input[type=\"radio\"]:checked + .radio-custom {\n    border-color: #0056b3;\n}\n\n.radio-label input[type=\"radio\"]:checked + .radio-custom::before {\n    transform: translate(-50%, -50%) scale(1);\n}\n\n.label-text {\n    font-size: 14px;\n    color: #4a4a4a;\n}\n\n.radio-label input[type=\"radio\"]:checked ~ .label-text {\n    color: #0056b3;\n    font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
